export default __webpack_public_path__ + "static/media/settings.8588567d.svg";